"use client";

import { useRouter } from "next/navigation";

import { routes } from "#/config/routes";
import { useShowEquityModal } from "#/store/app/equityModal/showEquityModal";

export const usePortfolioToastAction = () => {
  const router = useRouter();
  const { setShowEquityModal } = useShowEquityModal();

  const getAction = ({
    closeModal,
    target,
    label,
  }: {
    closeModal?: boolean;
    target: "history" | "index";
    label: string;
  }) => ({
    label,
    onClick: () => {
      if (closeModal) {
        setShowEquityModal(false);
      }
      router.push(routes.portfolio[target]);
    },
  });

  return { getAction };
};
